interface Props {
  label?: string;
}

// Subtle inline loading indicator — gold ring + text. Used in
// place of bare "Loading…" so panels feel like they're working,
// not stalled.
export default function Spinner({ label = "Loading" }: Props) {
  return (
    <p className="spinner" role="status" aria-live="polite">
      <span className="spinner__ring" aria-hidden="true" />
      <span className="spinner__label">{label}</span>
    </p>
  );
}
